import { useLinkProps } from '@react-navigation/native';
import type { FC } from 'react';
import type { ButtonProps, IconButtonProps } from 'react-native-paper';
import { Button, IconButton } from 'react-native-paper';

import type {
  NavigationItemProps,
  AppRoute
} from '@/navigation/types/navigation';

// See: https://reactnavigation.org/docs/link

export const NavigationButton: FC<NavigationItemProps & ButtonProps> = ({
  screen,
  params,
  action,
  href,
  children,
  ...rest
}) => {
  const linkProps = useLinkProps<AppRoute>({
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    screen,
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    params,
    action,
    href
  });

  return (
    <Button {...linkProps} {...rest}>
      {children}
    </Button>
  );
};

export const NavigationIconButton: FC<
  NavigationItemProps & IconButtonProps
> = ({ screen, params, action, href, ...rest }) => {
  const linkProps = useLinkProps<AppRoute>({
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    screen,
    // @ts-expect-error this is fine 🔥 | see useLinkProps definition
    params,
    action,
    href
  });

  return <IconButton {...linkProps} {...rest} />;
};
